import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getCoMaedcvPorTenant } from '../../helpers/api_helper';

const useObtenerCoMaedcvPorTenant = (limit = 100, refresh = 0) => {
    const [coMaedcv, setCoMaedcv] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const tenantId = useSelector((state) => state.Context.tenantId);
    const empresa = useSelector((state) => state.Context.empresa);

    useEffect(() => {
        const fetchCoMaedcv = async () => {
            if (!tenantId) return;

            setLoading(true);
            setError(null);
            try {
                const response = await getCoMaedcvPorTenant({
                    tenantId, limit, empresa
                });
                console.log('Response from API for co_maedcv by tenant:', response);
                setCoMaedcv(response.records);
            } catch (err) {
                const errorMessage = `Failed to fetch co_maedcv: ${err.message || 'Unknown error'}`;
                setError(errorMessage);
                console.error(errorMessage);
                setCoMaedcv(null);
            } finally {
                setLoading(false);
            }
        };

        fetchCoMaedcv();
    }, [tenantId, limit, refresh, empresa]);

    return { coMaedcv, loading, error };
};

export default useObtenerCoMaedcvPorTenant;